import React from "react";
import {
  cardsToShowLastFourOnRewardsBanner,
  MyTripsFilter,
  RewardsAccount,
} from "redmond";

export const NO_RESULTS_FOUND = "No results found";
export const NO_RESULTS_FOUND_MESSAGE =
  "Try searching another keyword to find what you are looking for.";
export const NO_RESULTS_FOUND_BUTTON_LABEL = "Clear search bar";
export const NO_TRIPS_WITH_OFFERS = "No eligible flights found";
export const NO_UPCOMING_TRIPS = "You have no upcoming trips.";
export const NO_WATCHED_TRIPS = "You aren't watching any trips.";
export const NO_TRIPS_FOUND = "No trips found";
export const NO_TRAVEL_CREDITS = "You don't have any airline travel credits.";
export const NO_PAST_TRIPS = "You don't have any past trips.";
export const ERROR_TITLE = "We are having trouble loading this page";
export const ERROR_SUBTITLE = "Please try again";
export const TRY_AGAIN = "Try again";

export const NO_UPCOMING_TRIPS_SUBTITLE =
  "Looks like it's time to plan your next one!";
export const NO_TRIPS_WITH_OFFERS_SUBTITLE =
  "It looks like you have no flights eligible to add flight disruption assistance at the moment.";

export const FLIGHTS_CTA = "Search flights";
export const HOTELS_CTA = "Search hotels";
export const CARS_CTA = "Search cars";

export const PAST_TRIP_ERROR = "Unable to load past trips.";
export const TRAVEL_CREDIT_ERROR = "Unable to load airline travel credits.";
export const UPCOMING_TRIP_ERROR = "Unable to load upcoming trips.";

export const getNoResultsTitle = (tripsFilter: MyTripsFilter) => {
  switch (tripsFilter) {
    case MyTripsFilter.UPCOMING_TRIPS:
      return NO_UPCOMING_TRIPS;
    case MyTripsFilter.WATCHED_TRIPS:
      return NO_WATCHED_TRIPS;
    case MyTripsFilter.TRAVEL_CREDITS:
      return NO_TRAVEL_CREDITS;
    case MyTripsFilter.PAST_TRIPS:
      return NO_PAST_TRIPS;
    case MyTripsFilter.TRIPS_WITH_OFFERS:
      return NO_TRIPS_WITH_OFFERS;
    default:
      return NO_TRIPS_FOUND;
  }
};

export const getNoResultsSubtitle = (tripsFilter: MyTripsFilter) => {
  switch (tripsFilter) {
    case MyTripsFilter.UPCOMING_TRIPS:
      return NO_UPCOMING_TRIPS_SUBTITLE;
    case MyTripsFilter.TRIPS_WITH_OFFERS:
      return NO_TRIPS_WITH_OFFERS_SUBTITLE;
    default:
      return null;
  }
};

export const getEarnText = (account: RewardsAccount) => {
  const {
    earn: { flightsMultiplier, hotelsMultiplier },
    rewardsBalance: { currencyDescription },
    productDisplayName,
    lastFour,
  } = account;

  const multiplier = currencyDescription?.includes("cash") ? "%" : "x";

  const lastFourText = cardsToShowLastFourOnRewardsBanner.includes(
    productDisplayName.toLowerCase()
  )
    ? ` ending in ${lastFour}`
    : ``;

  return flightsMultiplier ? (
    <>
      Earn{" "}
      <strong>
        {flightsMultiplier}
        {multiplier} {currencyDescription}
      </strong>{" "}
      on flights and{" "}
      <strong>
        {hotelsMultiplier}
        {multiplier} {currencyDescription}
      </strong>{" "}
      on hotels and car rentals when you book with your {productDisplayName}{" "}
      account{lastFourText}.
    </>
  ) : (
    <>
      Earn{" "}
      <strong>
        {hotelsMultiplier}
        {multiplier} {currencyDescription}
      </strong>{" "}
      on hotels and car rentals when you book with your {productDisplayName}{" "}
      account{lastFourText}.
    </>
  );
};

export const getErrorMessage = (tripsFilter: MyTripsFilter) => {
  switch (tripsFilter) {
    case MyTripsFilter.UPCOMING_TRIPS:
      return UPCOMING_TRIP_ERROR;
    case MyTripsFilter.PAST_TRIPS:
      return PAST_TRIP_ERROR;
    case MyTripsFilter.TRAVEL_CREDITS:
      return TRAVEL_CREDIT_ERROR;
    case MyTripsFilter.WATCHED_TRIPS:
    default:
      return ERROR_TITLE;
  }
};
